(function () {
var $776121dd101ef8fe$exports = {};
/*
TPI - https://vimeo.com/1158215889?fl=ip&fe=ec -> https://player.vimeo.com/video/1158215889

Unsung Heroes - https://vimeo.com/1154069665?fl=ip&fe=ec

Christmas Village - https://vimeo.com/1154067049?fl=ip&fe=ec

2025 Mayor’s Masked Ball - https://vimeo.com/1154065478?fl=ip&fe=ec

2025 Ayla Awards - https://vimeo.com/1154064401?fl=ip&fe=ec

*/ var $776121dd101ef8fe$var$embedParams = "&title=0&byline=0&portrait=0";
var $776121dd101ef8fe$var$sourceMap = {
    tpi: "https://player.vimeo.com/video/1158215889?autoplay=1".concat($776121dd101ef8fe$var$embedParams),
    unsung: "https://player.vimeo.com/video/1154069665?autoplay=1".concat($776121dd101ef8fe$var$embedParams),
    christmas: "https://player.vimeo.com/video/1154067049?autoplay=1".concat($776121dd101ef8fe$var$embedParams),
    masked: "https://player.vimeo.com/video/1154065478?autoplay=1".concat($776121dd101ef8fe$var$embedParams),
    ayla: "https://player.vimeo.com/video/1154064401?autoplay=1".concat($776121dd101ef8fe$var$embedParams)
};
function $776121dd101ef8fe$var$isKeyofSourceMap(key) {
    return !!key && key in $776121dd101ef8fe$var$sourceMap;
}
var $776121dd101ef8fe$var$buttons = document.querySelectorAll("button");
$776121dd101ef8fe$var$buttons.forEach(function(button) {
    button.addEventListener("click", function(event) {
        var key = event.currentTarget.dataset.videoKey;
        if ($776121dd101ef8fe$var$isKeyofSourceMap(key)) $776121dd101ef8fe$var$replaceVideo($776121dd101ef8fe$var$sourceMap[key]);
    });
});
function $776121dd101ef8fe$var$replaceVideo(nextSource) {
    var iframe = document.querySelector("iframe");
    iframe.src = nextSource;
}

})();
//# sourceMappingURL=video.1ec0fbcb.js.map
